import Image from 'next/image'

export default function BlueJobIcon( { complete } ) {
  // const { bg, fg1, fg2 } = getIconColors( complete )
  
  return (
    <Image width={ 100 } height={ 100 } sizes="100vw" style={ { width: '100%', aspectRatio: '1' } } src={ complete ? '/images/icons/blue-job-colour.png' : '/images/icons/blue-job-grey.png' } alt="Invent a Blue Job icon" />
  )
}
